"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clientGroupConfigsReducer = void 0;
var getAllDefaultTermDefinitions_1 = require("./actions/getAllDefaultTermDefinitions");
var getClientGroupConfig_1 = require("./actions/getClientGroupConfig");
var updateClientGroupConfig_1 = require("./actions/updateClientGroupConfig");
var types_1 = require("../../types");
var initialState = {
    data: {
        mainNavigation: {
            active: true,
            secured: true,
            keyName: types_1.ApplicationConfigKey.mainNavigation,
            properties: {
                activeColor: "#0172CE",
                copy: {
                    dashboard: "Home",
                    documents: "Documents",
                    menu: "Menu",
                    profile: "Profile",
                    reports: "Reports",
                },
            },
        },
        terms: undefined,
        defaultTerms: [],
    },
};
var parseDefaultGroupTerms = function (terms) {
    if (terms) {
        return terms.map(function (term) {
            return {
                id: term.visibleId,
                label: term.label,
                value: term.val,
            };
        });
    }
    return [];
};
var clientGroupConfigsReducer = function (state, action) {
    var _a;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case getClientGroupConfig_1.GET_CLIENT_GROUP_CONFIG:
        case updateClientGroupConfig_1.UPDATE_CLIENT_GROUP_CONFIG:
            return __assign(__assign({}, state), { data: __assign(__assign({}, state.data), (_a = {}, _a[action.keyName] = action.response, _a)) });
        case getAllDefaultTermDefinitions_1.GET_ALL_DEFAULT_TERM_DEFINITIONS:
            return __assign(__assign({}, state), { data: __assign(__assign({}, state.data), { defaultTerms: parseDefaultGroupTerms(action.response) }) });
        default:
            return state;
    }
};
exports.clientGroupConfigsReducer = clientGroupConfigsReducer;
//# sourceMappingURL=clientGroupConfigs.reducer.js.map